module.exports = ".boldText {\n  font-weight: 500; }\n\n.authuser-wrapper .card-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\n.btn-outline,\n.btn-danger,\n.btn-success {\n  color: #4A12F0;\n  border-color: #4A12F0;\n  background-color: #FFFFFF;\n  font-weight: bold;\n  border-radius: 60px; }\n\n.btn:hover {\n  background-color: #311eaa;\n  color: #C9FF27; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authuser/authuser.component.scss
// module id = ./src/app/authuser/authuser.component.scss
// module chunks = main